// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3FcsV","legacyBtn":"MutateMid_legacyBtn__3ZETA"};